import { render, staticRenderFns } from "./SignatureEmployerTool.vue?vue&type=template&id=631c8d16&scoped=true&"
import script from "./SignatureEmployerTool.vue?vue&type=script&lang=js&"
export * from "./SignatureEmployerTool.vue?vue&type=script&lang=js&"
import style0 from "./SignatureEmployerTool.vue?vue&type=style&index=0&id=631c8d16&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631c8d16",
  null
  
)

export default component.exports